module.exports = __webpack_public_path__ + "da5043e0ba5377d389f6d3069f8666a8.png";